export function calculate(answers) {
    const items = [];
  
    // Grant received check (first item)
    if (answers.previousCharger === 'Yes') {
      items.push('❌ The property has already received a grant');
    } else {
      items.push('✔️ The property has never received a grant');
    }
  
    // Parking requirements (second item)
    if (answers.houseType === 'House') {
      if (answers.suitableDriveway === 'No') {
        items.push('❌ The property does not meet the parking requirements');
      } else {
        items.push('✔️ The property meets the parking requirements');
      }
    } else if (answers.houseType === 'Apartment') {
      if (answers.privateParking === 'No') {
        items.push('❌ The property does not meet the parking requirements');
      } else {
        items.push('✔️ The property meets the parking requirements');
      }
    }
  
    // Determine eligibility based on negative items presence
    const isEligible = items.every(item => !item.startsWith('❌'));
    const status = isEligible ? 'You are Eligible' : 'You are Ineligible';
    const message = status === 'You are Eligible'
        ? "You meet all the requirements for the €300 EV Charger Grant"
        : "You do not meet the requirements for the €300 EV Charger Grant:";
    const color = status === 'You are Eligible'
        ? "green"
        : "red";
    const title = "Grant Qualification";
  
    return { status, items, message, color, title };
}
